import {Input, Table} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import UserDetailsButton from "../userDetails/UserDetailsButton";
import {useEffect, useState} from "react";
import {HttpService} from "../../services/http/Http.service";
import {HttpErrorService} from "../../services/http/HttpError.service";
import {PersonActivityDTO} from "../../model/models";
import {UtilsService} from "../../services/Utils.service";
import type { SortOrder } from 'antd/es/table/interface';

export default function Activity() {
    const [searchText, setSearchText] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [filteredData, setFilteredData] = useState<PersonActivityDTO[]>([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const toBeDone = false
    const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | undefined>('asc');
    const [sortField, setSortField] = useState<string | undefined>('scadenza');




    const columns = [
        {
            title: "Codice Fiscale",
            dataIndex: ['personDTO', 'fiscalCode'],
            key: "fiscalCode",
        },
        {
            title: "Cognome",
            dataIndex: ['personDTO', 'lastName'],
            key: "lastName",
        },
        {
            title: "Nome",
            dataIndex: ['personDTO', 'firstName'],
            key: "firstName",
        },
        {
            title: "Dipendente",
            dataIndex: ['callRegistryDTO', 'createdByUsername'],
            key: "createdByUsername",
        },
        {
            title: "Data nota",
            key: "dateNote",
            render: (record: PersonActivityDTO) => (UtilsService.formatDateString(record.callRegistryDTO?.createdAt))
        },
        {
            title: "Scadenza",
            key: "scadenza",
            dataIndex: "scadenza",
            sorter: true,
            defaultSortOrder: 'ascend' as const,
            sortDirections: ['ascend', 'descend'] as SortOrder[],
            render: (scadenza: string) => UtilsService.formatDateString(scadenza),
        },
        {
            title: "Azioni",
            key: "operation",
            render: (record: PersonActivityDTO) => (
                <UserDetailsButton personID={record.personDTO.id} combinatorID={record.callRegistryDTO.simulatorId}/>
            ),
        },
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchText(value);
    };

    const searchData = async (query: string) => {
        try {
            const data = await HttpService.getInstanceAxios().get('/activity/search', {
                params: {
                    keyword: query,
                    status: toBeDone,
                    page: currentPage - 1,
                    size: pageSize,
                    sort: sortField && sortOrder ? `${sortField},${sortOrder}` : undefined,
                }

            });
            setFilteredData(data.data.data.content)
            setTotalItems(data.data.data.totalElements)
        } catch (error) {
            HttpErrorService.handle('Errore durante la ricerca.', error, true)
        }
    };


    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchText);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchText]);


    useEffect(() => {
        const q = debouncedSearch;
        if (q.length > 0 && q.length < 3) return;
        searchData(q);
    }, [debouncedSearch, currentPage, sortField, sortOrder]);


    return (
        <>
            <div className={"container-search"}>
                <Input size="large"
                       style={{width: "100%", maxWidth: "480px"}}
                       allowClear
                       onChange={handleChange}
                       addonBefore={<SearchOutlined/>}
                       placeholder="Nome, Cognome, Codice Fiscale, Note"
                />
            </div>
            <Table
                dataSource={filteredData}
                columns={columns}
                rowKey="id"
                expandable={{
                    expandedRowRender: (record) => (
                        <p style={{ margin: 0 }}>
                            Nota chiamata: {record.callRegistryDTO.note}
                        </p>
                    ),
                }}
                pagination={{
                    showSizeChanger: false,
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalItems,
                    onChange: (page) => setCurrentPage(page),
                }}
                onChange={(pagination, filters, sorter) => {
                    if (!Array.isArray(sorter) && sorter.order && sorter.column?.dataIndex) {
                        setSortField(sorter.column.dataIndex as string);
                        setSortOrder(sorter.order === 'ascend' ? 'asc' : 'desc');
                    } else {
                        setSortField(undefined);
                        setSortOrder(undefined);
                    }
                }}

            />

        </>
    )
}